<template>
    <Table details :pagination="false" :tableData="detailsData" :class="{'table__column_size' : changeStyleColumns}">
        <template v-slot:head>
            <vs-th sort-key="name">{{i('global.Domains')}}</vs-th>
            <vs-th sort-key="domain_leads_total" class="column__data" >{{i('global.Leads')}}</vs-th>
            <vs-th sort-key="amount_leads_by_domain" class="column__data">{{i('global.Total')}}</vs-th>
            <vs-th sort-key="conversion" class="column__data">%</vs-th>
        </template>

        <template v-slot:content="{content}">
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{content.name}}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{content.domain_leads_total}}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{content.amount_leads_by_domain}}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{Number(content.conversion).toFixed(2)}}</p>
            </vs-td>
        </template>

        <template v-slot:details="{details}" >
            <DetailStatusesStatisticDomainAdv :detailsData="details.advertisers" />
        </template>
    </Table>
</template>

<script>
import Table from '@/components/custom-table/Table'
import i18n from '@/i18n/i18n'
import DetailStatusesStatisticDomainAdv from './DetailStatusesStatisticDomainAdv'
// import {mapGetters} from 'vuex'
import store from '@/store'
export default {
    props: {
        detailsData: {
            type: Array,
            default() {
                return []
            }
        },
        changeStyleColumns: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Table,
        DetailStatusesStatisticDomainAdv
    },

    computed: {
        userSelect() {
            return store.getters.userSelect
        }
    },

    methods: {
        i(val) {
            return i18n.tc(val)
        }
    }
}
</script>
